import React, { useState } from 'react';
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {customFormat, generateCustomSortAttributes} from "../../utils/dataTableUtils";
import {downloadExport} from "../../utils/exportUtils";
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';

function BaseTableView(props) {
  const [globalFilterValue, setGlobalFilterValue] = useState("");

    const idField = props.idField || "id";
    const getRowClass = (rowData) => {
        return {
            "p-highlight": (rowData[idField] === props.selectedId),
        }
    };

    const renderHeader = () => {
      return (
        <div className="p-input-icon-left">
          <InputText
            value={globalFilterValue}
            onChange={(e) => setGlobalFilterValue(e.target.value)}
            placeholder="🔍︎  Keyword Search"
          />
        </div>
      );
    };

    const getFilters = () => {
      const filters = {};
      props.tableFields.forEach(field => {
        filters[field.key] = { value: null, matchMode: FilterMatchMode.CONTAINS }
      });
      return {
        global: { value: globalFilterValue, matchMode: FilterMatchMode.CONTAINS },
        ...filters
      }
    }

    return (
        <div className="max-w-full">
            <div className="flex flex-wrap items-center">
                {props.extraElements}

                {props.addNewButton &&
                <div>
                    <Button label="New" onClick={() => {
                        props.setSelectedId(null);
                        props.setShowForm(true);
                    }}/>
                </div>}

                {props.downloadExport &&
                <div className="ml-8">
                    <Button label="Download export" onClick={() => downloadExport(props.exportUrl, props.exportFileName)}/>
                </div>
                }
            </div>
            {props.data.length > 0 &&
            <DataTable
                className="mt-4"
                value={props.data}
                rowClassName={getRowClass}
                onRowClick={(e) => {
                  if (props.setSelectedId && props.setShowForm) {
                    props.setSelectedId(e.data[idField]);
                    props.setShowForm(true);
                  }
                }}
                header={props.globalFilter ? renderHeader() : null}
                filters={getFilters()}
                emptyMessage={props.emptyMessage}
                filterDisplay = {(props.tableFields.some(field => field.filter===true)) ? 'row' : 'menu'}
            >
                {props.tableFields.map(field =>
                    <Column key={field.key}
                            field={field.key}
                            className={field.classNames}
                            header={field.header}
                            sortable={field.sortable}
                            {...generateCustomSortAttributes(field.customSort, props.data)}
                            filter={field.filter}
                            filterMatchMode="contains"
                            body={field.format ? (rowData, column) => customFormat({field, rowData, column, customColumn: props.customColumn}) : null}
                    />
                )}
            </DataTable>
            }

            {props.data.length === 0 &&
            <div>
              {props.emptyMessage ? props.emptyMessage : "No data is currently in the system"}
            </div>
            }
        </div>
    );
}

export default BaseTableView;